export default "__VITE_ASSET__CThPQXzy__"